// utils/messageUtils.js
export const messageUtils = {
    getEmptyStateMessage: (variant, language = 'en') => {
        const messages = {
            en: {
                checkout: "No items in cart",
                cart: "Your bag is empty!",
                default: "No items to display"
            },
            ar: {
                checkout: "لا توجد عناصر في السلة",
                cart: "حقيبتك فارغة!",
                default: "لا توجد عناصر للعرض"
            }
        };

        const t = messages[language] || messages.en;
        return t[variant] || t.default;
    },

    getLoadingMessage: (language = 'en') => {
        const messages = {
            en: "Loading...",
            ar: "جاري التحميل..."
        };
        return messages[language] || messages.en;
    }
};
